<div class="documents-toast">
    <div class="toast-container">
        <div class="documents-success icon"></div>
        <div class="toast-text">{{ text[type] || type }}</div>
    </div>
</div>